export function hasLowerCase(str: string) {
  return /[a-z]/.test(str);
}

export function hasUpperCase(str: string) {
  return /[A-Z]/.test(str);
}

export function hasDigit(str: string) {
  return /[0-9]/.test(str);
}

export function isLengthEnought(str: string) {
  return str.length >= 8;
}

export type PasswordComplexity = {
  minLength: number;
  minLowerCase: number;
  minUpperCase: number;
  minNumber: number;
  minSymbol: number;
  excludeUsername: boolean;
  excludeAttributes?: Array<string>;
};

export function isValidPassword(str: string) {
  return hasLowerCase(str) && hasUpperCase(str) && hasDigit(str) && isLengthEnought(str);
}
